import { Link } from 'react-router-dom';

export type CreateNotice =
  | { kind: 'failed'; organizationId: string }
  | { kind: 'skipped' };

interface CreateOrganizationNoticeProps {
  notice: CreateNotice;
  /** Where the detail view's "Back to Organizations" should return to. */
  backTo: string;
}

/**
 * Follow-up after an organization is created but its sample data did not land. The organization
 * itself exists either way, so this is a warning to act on, not an error. The caller owns the live
 * region around it.
 */
export const CreateOrganizationNotice = ({ notice, backTo }: CreateOrganizationNoticeProps) => (
  <div className="admin-section__notice" data-testid="create-org-sample-data-notice">
    {notice.kind === 'failed' ? (
      <>
        The organization was created, but sample data could not be added.{' '}
        {notice.organizationId ? (
          <Link
            to={`/admin/organizations/${notice.organizationId}`}
            state={{ from: backTo }}
            className="admin-section__notice-link"
            data-testid="create-org-sample-data-notice-link"
          >
            Open the organization to try again.
          </Link>
        ) : (
          'Open the organization to try again.'
        )}
      </>
    ) : (
      'No sample data template is saved yet, so none was added.'
    )}
  </div>
);
